import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPreAuthState, wizard } from "../interfaces/IPreAuth";
import { wizardSteps } from "../props/PreAuthProps";
import {
  fetchCreditNoteData,
  fetchPortalData,
  // fetchPortalStatusList,
  fetchPortalStatusList,
  fetchVisitStageStatus,
  getPreAuthStepper,
  postCreditNoteData,
} from "../apis/patientService";
import { fetchPortalDataCghs, fetchPortalDataCghsNew } from "../apis/SchemeService/CGHS/cghsService";
import { getPreAuthIhx, postPreAuthIhx, updatePreAuthIhx } from "../apis/PreAuthService";
import { fetchPortalDataEchs } from "../apis/SchemeService/ECHS/echsService";
import { fetchPortalDataStarHealth } from "../apis/SchemeService/STARHEALTH/starHealthService";
const initialState: IPreAuthState = {
  allWizardSteps: wizardSteps,
  currentStep: 0,
  portalData: null,
  isFetchingPortalData: false,
  isFetchingStepperData: false,
  preAuthUrlLink: null,
  creditNoteData: null,
  stepperData: {
    currentVisitStage: {
      stateId: null,
      canNavigate: false,
      completed: false,
      isCurrentStage: false,
      stageLevelId: null,
      step: null,
      visitStage: null,
      visitStageId: null,
      state: null,
    },
    schemeMetaDataResponse: null,
    visitStages: [],
    visitTypes: null,
  },
  stageAllState: null,
  schemePortalStatusList: null,
  // stageAllState: null,  
  // schemePortalStatusList: null,
};

export const getPortalData = createAsyncThunk(
  "preAuth/getPortalData",
  async ({ caseId, visitId }: { caseId: number; visitId: number }) => {
    const response = await fetchPortalData(caseId, visitId);
    if (typeof response === "object") {
      return response;
    } else {
      return null;
    }
  }
);

export const getPortalDataStarhealth = createAsyncThunk(
  "preAuth/getPortalDataStarhealth",
  async ({ caseId, visitId }: { caseId: number; visitId: number }) => {
    const response = await fetchPortalDataStarHealth(caseId, visitId);
    if (typeof response === "object") {
      return response;
    } else {
      return null;
    }
  }
);

export const getPortalDataCghs = createAsyncThunk(
  "preAuth/getPortalDataCghs",
  async ({ caseId, visitId }: { caseId: number; visitId: number }) => {
    const response = await fetchPortalDataCghs(caseId, visitId);
     if (typeof response === "object") {
      return response;
    } else {
      return null;
    }
  }
);

export const getPortalDataCghsNew = createAsyncThunk(
  "preAuth/getPortalDataCghs",
  async ({ caseId, visitId }: { caseId: number; visitId: number }) => {
    const response = await fetchPortalDataCghsNew(caseId, visitId);
     if (typeof response === "object") {
      return response;
    } else {
      return null;
    }
  }
);

export const getPortalDataIhx = createAsyncThunk(
  "preAuth/getPortalDataIhx",
  async ({ caseId, visitId }: { caseId: number; visitId: number }) => {
    const response = await getPreAuthIhx(caseId, visitId);
    if (typeof response === "object") {
      return response;
    } else {
      return null;
    }
  }
);

export const getPortalDataEchs = createAsyncThunk(
  "preAuth/getPortalDataEchs",
  async ({ caseId, visitId }: { caseId: number; visitId: number }) => {
    try {
      const response = await fetchPortalDataEchs(caseId, visitId);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchPreAuthStepper = createAsyncThunk(
  "preAuth/fetchPreAuthStepper",
  async ({ caseId, visitId }: { caseId: number; visitId: number }) => {
    const response = await getPreAuthStepper(caseId, visitId);
    if (typeof response === "object") {
      return response;
    } else {
      return null;
    }
  }
);

export const fetchStepperData = createAsyncThunk(
  "preAuth/fetchStepperData",
  async ({ caseId, visitId }: { caseId: number; visitId: number }) => {
    const response = await getPreAuthStepper(caseId, visitId);
    if (typeof response === "object") {
      return response;
    } else {
      return null;
    }
  }
);

export const getCreditNoteData = createAsyncThunk(
  "preAuth/getCreditNoteData",
  async ({ visitId }: { visitId: number }) => {
    const response = await fetchCreditNoteData(visitId);
    if (typeof response === "object") {
      return response;
    } else {
      return null;
    }
  }
);

export const getVisitStageStates = createAsyncThunk(
  "preAuth/getVisitStageStates",
  async ({ visitStageId }: { visitStageId: number }) => {
    const response = await fetchVisitStageStatus(visitStageId);
    if (typeof response === "object") {
      return {
        visitStageId: visitStageId,
        data: response,
      };
    } else {
      return null;
    }
  }
);

// export const getPortalStatusList = createAsyncThunk(
//   "preAuth/getPortalStatusList",
//   async ({ schemeId }: { schemeId: number }) => {
//     const response = await fetchPortalStatusList(schemeId);
//     if (typeof response === "object") {
//       return {
//         schemeId: schemeId,
//         data: response,
//       };
//     } else {
//       return null;
//     }
//   }
// );

export const submitCreditNoteData = createAsyncThunk(
  "preAuth/submitCreditNoteData",
  async ({ visitId, formData }: { visitId: number; formData: any }) => {
    const response = await postCreditNoteData(visitId, formData);
    if (typeof response === "object") {
      return response;
    } else {
      return null;
    }
  }
);

export const getPortalStatusList = createAsyncThunk(
  "preAuth/getPortalStatusList",
  async ({ schemeId }: { schemeId: number }) => {
    const response = await fetchPortalStatusList(schemeId);
    if (typeof response === "object") {
      return {
        schemeId: schemeId,
        data: response,
      };
    } else {
      return null;
      }
    }
  );

export const postPreAuthData = createAsyncThunk<any, any, { rejectValue: any }>(
  "preAuth/postPreAuthData",
  async ({ caseId, visitId, payload }, { rejectWithValue }) => {
    try {
      const data = await postPreAuthIhx(caseId, visitId, payload);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

export const updatePreAuthData = createAsyncThunk<any, any, { rejectValue: any }>(
  "preAuth/updatePreAuthData",
  async ({ caseId, visitId, casePreAuthId, payload }, { rejectWithValue }) => {
    try {
      const data = await updatePreAuthIhx(caseId, visitId, casePreAuthId, payload);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// export const getPortalStatusList = createAsyncThunk(
//   "preAuth/getPortalStatusList",
//   async ({ schemeId }: { schemeId: number }) => {
//     const response = await fetchPortalStatusList(schemeId);
//     if (typeof response === "object") {
//       return {
//         schemeId: schemeId,
//         data: response,
//       };
//     } else {
//       return null;
//     }
//   }
// );

const preAuthSlice = createSlice({
  name: "preAuth",
  initialState: initialState,
  reducers: {
    nextStep: (state) => {
      if (state.currentStep < wizardSteps.length - 1) {
        state.currentStep += 1;
        // state.currentStep = wizardSteps[state.currentStep+1]?.steps;
      }
    },
    nextStep2: (state) => {
      if (state.currentStep < state.stepperData.visitStages.length - 1) {
        state.currentStep += 1;
        // state.currentStep = wizardSteps[state.currentStep+1]?.steps;
      }
    },
    prevStep: (state) => {
      if (state.currentStep > 0) {
        state.currentStep -= 1;
        // state.currentStep = wizardSteps[state.currentStep-1]?.steps;
      }
    },
    setWizards: (state, action: PayloadAction<Array<wizard>>) => {
      state.allWizardSteps = action.payload;
    },
    setCanNavigate: (
      state,
      action: PayloadAction<{ step: number; canNavigate: boolean }>
    ) => {
      const { step, canNavigate } = action.payload;
      if (state.allWizardSteps[step]) {
        state.allWizardSteps[step].canNavigate = canNavigate;
        state.allWizardSteps[step].completed = canNavigate;
      }
    },
    resetStep: (state) => {
      state.currentStep = 0;
    },
    resetPortalData: (state) => {
      state.portalData = null;
    },
    clearAllWizardSteps: (state) => {
      state.allWizardSteps = wizardSteps;
    },
    setCurrentStep(state, action: PayloadAction<number>) {
      state.currentStep = action.payload;
    },
    setPreAuthUrlLink(state, action: PayloadAction<string>) {
      state.preAuthUrlLink = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPortalData.pending, (state) => {
        state.isFetchingPortalData = true;
        // Update the preAuthUrlLink property with the new URL from the action payload
      })
      .addCase(getPortalData.fulfilled, (state, action: PayloadAction<any>) => {
        state.isFetchingPortalData = false;
        state.portalData = action.payload;
      })
      .addCase(getPortalData.rejected, (state) => {
        state.isFetchingPortalData = false;
      })
      .addCase(getPortalDataCghs.pending, (state) => {
        state.isFetchingPortalData = true;
        // Update the preAuthUrlLink property with the new URL from the action payload
      })
      .addCase(getPortalDataCghs.fulfilled, (state, action: PayloadAction<any>) => {
        state.isFetchingPortalData = false;
        state.portalData = action.payload;
      })
      .addCase(getPortalDataCghs.rejected, (state) => {
        state.isFetchingPortalData = false;
      })

      .addCase(getPortalDataStarhealth.pending, (state) => {
        state.isFetchingPortalData = true;
        // Update the preAuthUrlLink property with the new URL from the action payload
      })
      .addCase(getPortalDataStarhealth.fulfilled, (state, action: PayloadAction<any>) => {
        state.isFetchingPortalData = false;
        state.portalData = action.payload;
      })
      .addCase(getPortalDataStarhealth.rejected, (state) => {
        state.isFetchingPortalData = false;
      })

      .addCase(getPortalDataIhx.pending, (state) => {
        state.isFetchingPortalData = true;
        // Update the preAuthUrlLink property with the new URL from the action payload
      })
      .addCase(getPortalDataIhx.fulfilled, (state, action: PayloadAction<any>) => {
        state.isFetchingPortalData = false;
        state.portalData = action.payload;
      })
      .addCase(getPortalDataIhx.rejected, (state) => {
        state.isFetchingPortalData = false;
      })
      .addCase(getPortalDataEchs.pending, (state) => {
        state.isFetchingPortalData = true;
      })
      .addCase(
        getPortalDataEchs.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.isFetchingPortalData = false;
          state.portalData = action.payload;
        }
      )
      .addCase(getPortalDataEchs.rejected, (state) => {
        state.isFetchingPortalData = false;
      })
      .addCase(fetchPreAuthStepper.pending, (state) => {
        state.isFetchingPortalData = true;
      })
      .addCase(
        fetchPreAuthStepper.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.isFetchingPortalData = false;
          const updatedVisitSchemeStage = action.payload.visitStages?.filter((stage: any) => stage?.visitStage !== "Enhancement" && stage?.visitStage !== "Extension Of Stay" && stage?.visitStage !== "Unlisted Procedures");
          state.stepperData = {...action.payload, visitStages: updatedVisitSchemeStage};
          // state.currentStep = 0;

          updatedVisitSchemeStage?.forEach((stage: any) => {
            if (
              stage.stageLevelId ===
              action.payload.currentVisitStage.stageLevelId
            ) {
              state.currentStep = action.payload.visitStages?.indexOf(stage);
              if (state.stepperData.currentVisitStage) {
                state.stepperData.currentVisitStage.step =
                  action.payload.visitStages.indexOf(stage);
              }
            }
          });
        }
      )
      .addCase(fetchStepperData.rejected, (state) => {
        state.isFetchingPortalData = false;
      })
      .addCase(fetchStepperData.pending, (state) => {
        state.isFetchingPortalData = true;
      })
      .addCase(
        fetchStepperData.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.isFetchingPortalData = false;
          const updatedVisitSchemeStage = action.payload.visitStages?.filter((stage: any) => stage?.visitStage !== "Enhancement" && stage?.visitStage !== "Extension Of Stay" && stage?.visitStage !== "Unlisted Procedures");
          state.stepperData = {...action.payload, visitStages: updatedVisitSchemeStage};
          // state.stepperData = action.payload;
        }
      )
      .addCase(fetchPreAuthStepper.rejected, (state) => {
        state.isFetchingPortalData = false;
      })
      .addCase(getCreditNoteData.pending, (state) => {
        state.isFetchingPortalData = true;
        state.creditNoteData = null;
      })
      .addCase(
        getCreditNoteData.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.isFetchingPortalData = false;
          state.creditNoteData = action.payload;
        }
      )
      .addCase(getCreditNoteData.rejected, (state) => {
        state.isFetchingPortalData = false;
        state.creditNoteData = null;
      })
      .addCase(submitCreditNoteData.pending, (state) => {
        state.isFetchingPortalData = true;
        state.creditNoteData = null;
      })
      .addCase(
        submitCreditNoteData.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.isFetchingPortalData = false;
          state.creditNoteData = action.payload;
        }
      )
      .addCase(submitCreditNoteData.rejected, (state) => {
        state.isFetchingPortalData = false;
        state.creditNoteData = null;
      })
      .addCase(getVisitStageStates.pending, (state) => {
        state.stageAllState = null;
      })
      .addCase(
        getVisitStageStates.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.stageAllState = {
            ...state.stageAllState,
            [action.payload.visitStageId]: action.payload.data,
          };
        }
      )
      .addCase(getVisitStageStates.rejected, (state) => {
        state.stageAllState = null;
      })
      // .addCase(getPortalStatusList.pending, (state) => {
      //   state.schemePortalStatusList = null;
      // })
      // .addCase(
      //   getPortalStatusList.fulfilled,
      //   (state, action: PayloadAction<any>) => {
      //     state.schemePortalStatusList = action?.payload?.data;
      //   }
      // )
      // .addCase(getPortalStatusList.rejected, (state) => {
      //   state.schemePortalStatusList = null;
      // })
      .addCase(getPortalStatusList.pending, (state) => {
        state.schemePortalStatusList = null;
      })
      .addCase(
        getPortalStatusList.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.schemePortalStatusList = action?.payload?.data;
        }
      )
      .addCase(getPortalStatusList.rejected, (state) => {
        state.schemePortalStatusList = null;
      });
  },
});

export const {
  nextStep,
  nextStep2,
  prevStep,
  setWizards,
  clearAllWizardSteps,
  resetStep,
  setCanNavigate,
  setCurrentStep,
  resetPortalData,
  setPreAuthUrlLink,
} = preAuthSlice.actions;
export default preAuthSlice.reducer;
